export class ExtraQuestionAnswer {
    constructor(id, text, user, extraQuestionOption, srqCompleted) {
        this.id = id;
        this.text = text;
        this.user = user;
        this.extraQuestionOption = extraQuestionOption;
        this.srqCompleted = srqCompleted;
    }
}
